import React, { memo } from 'react'
import ActivityTimelineFile from './activity-timeline-file/activity-timeline-file'
import ActivityTimelineNote from './activity-timeline-note/activity-timeline-note'
import ActivityTimelineAvito from './activity-timeline-avito/activity-timeline-avito'
import ActivityTimelineTask from './activity-timeline-task/activity-timeline-task'
import ActivityTimelineStage from './activity-timeline-stage/activity-timeline-stage'
import ActivityTimelineInfo from './activity-timeline-info/activity-timeline-info'
import ActivityTimelineCall from './activity-timeline-call/activity-timeline-call'
import ActivityTimelinePayment from './activity-timeline-payment/activity-timeline-payment'
import { ActivityItem } from '../../types/types'

export interface TimelineItemProps extends ActivityItem {
  index: number
  scopeDate: number | string
}

const TimelineItem: React.FC<TimelineItemProps> = memo((props: TimelineItemProps) => {
  const { type } = props
  switch (type) {
    case 'stage':
      return <ActivityTimelineStage {...props} />
    case 'info':
      return <ActivityTimelineInfo {...props} />
    case 'file':
      return <ActivityTimelineFile {...props} />
    case 'note':
      return <ActivityTimelineNote {...props} />
    case 'call':
      return <ActivityTimelineCall {...props} />
    case 'task':
      return <ActivityTimelineTask {...props} />
    case 'avito':
      return <ActivityTimelineAvito {...props} />
    case 'payment':
      return <ActivityTimelinePayment {...props} />
    default:
      return null
  }
})

TimelineItem.displayName = 'TimelineItem'
export default TimelineItem
